import { LinkResendOutcome } from 'services/deep-link-signin';

/**
 * Asks the server for a fresh sign-in link and says what happened, for the
 * Subscribe page's "Can't find the email? → Resend Link". Outside the component
 * so it is unit-testable without Angular, like `purchase-offer-policy.ts` next
 * door.
 *
 * The page used to send the link and announce it inside one `try`, so a send
 * that threw skipped the announcement and the user was told nothing at all
 * (df-26428200b880). Deciding the outcome first, and only then choosing the
 * message, gives the failed send a message of its own. It answers with the
 * same outcomes the account-switch path uses in `services/deep-link-signin.ts`.
 *
 * Never throws: a failed send is handed to `reportFailure` and answered as
 * `SendFailed`, so the caller always has a message to show.
 */
export async function resendSignInLinkAsync(
  send: () => Promise<{ accountAmbiguous?: boolean } | null | undefined>,
  reportFailure: (err: unknown) => void,
): Promise<LinkResendOutcome> {
  try {
    const result = await send();
    // several accounts on the address means the server deliberately sent nothing (#4505).
    return result?.accountAmbiguous ? LinkResendOutcome.AccountAmbiguous : LinkResendOutcome.Sent;
  } catch (err) {
    reportFailure(err);
    return LinkResendOutcome.SendFailed;
  }
}
